import React from 'react';
import ContactSection from '../Components/ContactSection/ContactSection';
import CreativeContact from '../Components/CreativeContact/CreativeContact';




const Contact = () => {
  return (
    <>
      
      <ContactSection />
      <CreativeContact />
    
     
      
    </>
  );
};

export default Contact;
